import { api } from "./api";

/** Stable dancer id used by the API for a signed-in account (see ensureDancerForAccount). */
export function accountLinkedDancerId(accountId) {
  if (!accountId) return null;
  return `od-${accountId}`;
}

/**
 * First non-empty phone from profile / account fields used for RSVP prefills.
 */
export function resolveProfilePhone({ profile, account } = {}) {
  const candidates = [
    profile?.phone,
    account?.phone,
    account?.default_payment?.contact_phone,
  ];
  for (const raw of candidates) {
    const trimmed = String(raw || "").trim();
    if (trimmed) return trimmed;
  }
  return "";
}

/**
 * Load the guest dance profile for the current user.
 * Tries local dancer_id, then the account-linked dancer, then phone match.
 */
export async function loadDancerProfile({ dancerId, account, organizer }) {
  account = account ?? organizer;
  const candidates = [];
  if (dancerId) candidates.push(dancerId);
  const linkedId = accountLinkedDancerId(account?.id);
  if (linkedId && linkedId !== dancerId) candidates.push(linkedId);

  for (const id of candidates) {
    try {
      const r = await api.get(`/dancers/${id}`);
      return { id: r.data.id, ...r.data };
    } catch {
      // try next candidate
    }
  }

  if (account?.phone) {
    try {
      const r = await api.get(`/dancers/by-phone/${encodeURIComponent(account.phone)}`);
      if (r.data.found && r.data.dancer) {
        return { ...r.data.dancer };
      }
    } catch {
      // no profile
    }
  }
  return null;
}

export function dancerHasDanceDetails(profile) {
  return Boolean(profile?.role && (profile?.dance_forms || []).length > 0);
}
